module.exports = __webpack_public_path__ + "static/img/djvu.5e77674.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon_suffix/djvu.png
// module id = KCPu
// module chunks = 53